import React, { FunctionComponent } from 'react'

import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import ArrowLeft from '../../icons/ArrowLeft'
import DisplayFlex from '../StyledElems/DisplayFlex'
import {
  NavBar,
  IconWrapper,
  Title,
//  Notifications,
//  UserInfo
} from './components'
import UserInfo from './UserInfo'
import Notifications from './Notifications'

type Prop = {
  title: string;
}
const Flex = styled(DisplayFlex)`
  width: calc(100% - 200px);
  overflow: hidden;
  text-overflow: ellipsis;
`
const Menu: FunctionComponent<Prop> = ({ title }) => {
  const history = useHistory()
  const goBack = () => history.goBack()
  return (
    <>
      <NavBar>
        <Flex alignItems="center">
          <IconWrapper>
            <ArrowLeft onClick={goBack} />
          </IconWrapper>
          <Title>{title}</Title>
        </Flex>
        <DisplayFlex alignItems="center">
          <Notifications />
          <UserInfo />
        </DisplayFlex>
      </NavBar>
    </>
  )
}

export default Menu
